import React, { useState } from 'react'
import { IconButton, TableCell, TableRow } from '@mui/material'
import Delete from './Delete'
import DeleteIcon from '@mui/icons-material/Delete'

const Row = ({ data, refetch }) => {
  const [openDelete, setOpenDelete] = useState(false)

  return (
    <>
      <TableRow>
        <TableCell>{data.displayName}</TableCell>
        <TableCell>{data.phoneNumber}</TableCell>
        <TableCell>
          <IconButton color='error' onClick={() => setOpenDelete(true)} size='small'>
            <DeleteIcon />
          </IconButton>
        </TableCell>
      </TableRow>
      <Delete
        data={data}
        onClose={() => setOpenDelete(false)}
        openDelete={openDelete}
        refetch={refetch}
      />
    </>
  )
}

export default Row
